export default __webpack_public_path__ + "static/header-title-dont-dark-1860d5fd8c74b1ad47e3859b39e480b3.png";